export let dt = 1 / 60;
export let time = 0;

export function start(update: (dt: number) => void, render?: () => void): void {
  let prev = 0;
  const frame = (timestamp: number) => {
    if (prev === 0) prev = timestamp;
    const raw = (timestamp - prev) / 1000;
    prev = timestamp;
    dt = Math.min(raw, 1 / 6);
    time += dt;
    update(dt);
    if (render) render();
    requestAnimationFrame(frame);
  };
  requestAnimationFrame(frame);
}
